import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const allyaTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#d0006f',
    },
    secondary: {
      main: '#ff671f',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#d0006f',
    },
  },
};
